module.exports = __webpack_public_path__ + "img/jibenxinxi.bb93dcc8.png";